import { BreadCrumbItem, BreadCrumbs } from '@eventbrite/breadcrumbs-infra';
import React from 'react';

export interface Breadcrumb {
    title: string;
    relative_url: string;
    absolute_url: string;
}

interface ThingsToDoBreadcrumbsProps {
    breadcrumbs: Breadcrumb[];
}

export const ThingsToDoBreadcrumbs: React.FunctionComponent<
    ThingsToDoBreadcrumbsProps
> = (props) => {
    const breadcrumbItems = React.useMemo<BreadCrumbItem<{}>[]>(() => {
        const items: BreadCrumbItem<{}>[] = props.breadcrumbs.map(
            (breadcrumb) => {
                return {
                    value: breadcrumb.relative_url,
                    display: breadcrumb.title,
                };
            },
        );
        return items;
    }, [props]);

    return (
        <BreadCrumbs
            items={breadcrumbItems}
            separator={
                <span style={{ paddingLeft: '8px', paddingRight: '8px' }}>
                    /
                </span>
            }
        >
            {(item: BreadCrumbItem<{}>) => (
                <a href={item.value} title={item.display.toString()}>
                    {item.display}
                </a>
            )}
        </BreadCrumbs>
    );
};
